export default "__VITE_ASSET__DoSfcgoY__"